import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { KeyValuePair } from 'src/shared/shared.types';

export interface TableCellFields {
  TableData?: RichTextField;
  Icon?: KeyValuePair;
  CellAlignment?: KeyValuePair;
  children?: ChildItemData[];
}

export interface DataRowFields {
  CellAlignment?: KeyValuePair;
}

export interface HeaderRowFields {
  CellAlignment?: KeyValuePair;
}

export interface TableFields {
  fields?: {
    Headline?: Field<string>;
    SupportCopy?: RichTextField;
  };
  children?: ChildItemData[];
}

export interface ChildItemData {
  id?: string;
  templateId?: string;
  name?: string;
  fields?: TableCellFields | DataRowFields | HeaderRowFields;
  children?: ChildItemData[];
}
